module.exports = __webpack_public_path__ + "static/media/linkedin.f5319c12.webp";